import { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import "../../../../Styles/dsc.css";
import { config } from "../../../CommonUtilities/CommonUrl/CommonUrls";
import { CommonAxiosGet } from "../../../CommonUtilities/CommonAxios/CommonAxios";
import { useReactToPrint } from "react-to-print";
import { CommonPageHeading } from "../../../CommonUtilities/CommonHeading/CommonPageHeading";
import { numberToWordsIndian } from "../../../CommonUtilities/CommonFunctions/CommonFunction";
import { FaFilePdf, FaPrint, } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ACADEMIC_YEAR, CONTEXT_NAME } from "../../../CommonUtilities/Validations/RegularExpAndVar";
export const inst_res = [
 { label: "The TET (20%) weightage has been added based on the available records.", }]
export const ScoreDetails = (props) => {
  const { resultData, from } = props;
  return (
  <div className="table-responsive align-center rounded-results">
    <table className='table results-table table-bordered' role="presentation">
      <thead>
        <tr className="tr-first"><th rowSpan={2} className="text-center"> PAPER (Medium) </th>
          {/* <th colSpan={2} className="text-center"> EXAM SCORE</th> */}
          {/* <th colSpan={2} className="text-center">TET</th> */}
          {/* <th rowSpan={2} className="text-center">TOTAL SCORE<br />(vi) = (iii) + (v)</th> */}
          {/* {from === 'ScoreCard' && <th rowSpan={2}>Status</th>} */}
        </tr>
        <tr className="tr-second"> <th>MARKS SECURED</th>
          <th> NORMALIZED SCORE</th>
           {/* <th> RESULT </th> */}
          {/* <th>SCORE<br />(iv)</th> */}
          {/* <th> WEIGHTAGE<br />(v)</th> */}
          </tr>
      </thead>
      <tbody>
        {resultData?.map((val, i) => {
          return (
            <tr key={i} >
              <td>{val?.post_name}</td>
              <td className="text-center">{val?.total_score} </td>
              <td>{val?.normalised_score} &nbsp; ({val?.normalised_score && `${numberToWordsIndian(val?.normalised_score)} Only`})</td>
              {/* <td>{val?.tet_marks}</td>
              <td>{val?.tet_score}</td> */}
              {/* <td>{val?.total_score}  ({val?.total_score && `${numberToWordsIndian(val?.total_score)} Only`})</td> */}
              {/* <td>{val?.qualified_flag}</td> */}
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
  )}
export default function Results() {
  const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails.loginData);
  const [showRstatus, setRstatus] = useState("");
  const [resultData, setResultData] = useState([]);
  const [imgData, setImgData] = useState(null)
  function getDataFunctionResult() {

    // const url = `${config.url.CONTEXT_READ_URL}getScoreCard`;
    const url = `${config.url.CONTEXT_READ_URL}get-tet-score-card`;
    CommonAxiosGet(url).then((response) => {
      if (response?.data?.status === true) {
        const posts = response?.data?.data;
        setResultData(posts);
        setImgData(posts[0]?.img_path)

      } else {
        setImgData()
        setRstatus(false);
        setResultData([]);
      }
    })
  };
  const componentRef = useRef();
  const handleprint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `${resultData[0]?.candidate_id}_Marks`,
    pageStyle: `
               @media print {
               .person-details {
            margin-top: 5px;
            display: flex;
            align-items: flex-start;
            /* for multiline alignment */
            margin-bottom: 8px;
        }
        .label {
            width: 150px;
            /* fixed width to align colons */
            margin: 0;
            font-weight: bold;
        }
        .value {
            display: flex;
            gap: 6px;
            flex: 1;
            margin: 0;
        }
        .colon {
            min-width: 10px;
        }}
           `,
  });
  useEffect(() => {
    getDataFunctionResult()
  }, []);

  let navigate = useNavigate()
  const service = useSelector((state) => state.reducers.loginreducer.loginDetails);
  const hasResultsAccess = service?.roleServices?.some(val => val?.target === '/TetObjections');
  return (
    <div>
      <CommonPageHeading heading={`${CONTEXT_NAME} - ${ACADEMIC_YEAR} Results`} drillBack='true' handleDrillBack={() => { if (showRstatus === true) { setRstatus("") } else { navigate(-1) } }} />
      {showRstatus === "" && <Row className="mt-4"><Col md={2}></Col>
        <Col md={8} className="text-error text-center mt-4">
          <h5 className="pt-4" style={{ color: "black" }}> Dear <span style={{ color: "brown" }}>  {loginreducer?.applicant_name}</span>,
            <button type="button" onClick={() => { setRstatus(true); }} className="btn btn-link btn-sm">
              👉 Click here</button>to View Your AP TET-2025 Score Card.
          </h5><br /><br />
          {/* {hasResultsAccess &&
            <h6><span className="text-danger"> Note : If you have any objections regarding your TET highest score <br />
              <button type="button" onClick={() => { navigate('/TetObjections') }} className="btn btn-link btn-sm">
                👉 Click here</button> to provide your correct TET highest score details.</span>
              <button className="btn btn-link btn-sm" type="button" onClick={() => {
                window.open(`${process.env.PUBLIC_URL}/DSC-PDF/UserManuals/DSC Results User Manual.pdf`, '_blank');
              }}> <FaFilePdf />User Manual</button> </h6>} */}
        </Col><Col md={2}></Col> </Row>}
      {showRstatus === true && (
        <div className=""><center className="mb-2">
          <button className="btn btn-secondary rounded-0" variant="primary" type="button" onClick={() => {
            handleprint()
          }}>Print&nbsp; <FaPrint title="Print" style={{ fontSize: '22px' }} /> </button></center>
          <div className="Score-card-main" ref={componentRef}>
            <div className="score-page-head-part">
              <div className="score-page-head">
                <img src="img/aplogo-new.svg" className="img-fluid" alt="logo-results" /> 
                {/* aplogo-new */}
                <div className="logo-text">
                  <h3>DEPARTMENT OF SCHOOL EDUCATION, ANDHRA PRADESH</h3>
                  <span><h4>TEACHER ELIGIBILITY TEST - (APTET), OCTOBER 2025</h4></span>
                </div>
              </div>
              <div className="score-strip">
                {/* <p>SCORE CARD</p> */}
                 <p>MARKS MEMO</p>
              </div>
            </div>
            <div className="total-details-body">
              <div className="personal-details">
                <div className="personal-text">
                  <div className="personal-content">
                    <p>Hall Ticket Number</p><span>:</span><h6>{resultData[0]?.hall_ticket}</h6>
                  </div>
                   <div className="personal-content">
                    <p>Candidate Id</p><span>:</span><h6>{resultData[0]?.candidate_id}</h6>
                  </div>
                  <div className="personal-content">
                    <p>Candidate Name</p><span>:</span><h6>{resultData[0]?.applicant_name}</h6>
                  </div>
                  <div className="personal-content">
                    <p>Father Name</p><span>:</span><h6>{resultData[0]?.father_name}</h6>
                  </div>
                  <div className="personal-content">
                    <p>Gender</p><span>:</span><h6>{resultData[0]?.gender}</h6>
                  </div>
                  <div className="d-flex w-100">
                  <div className="personal-content w-50">
                    <p className="dob">Date Of Birth</p><span>:</span><h6>{resultData[0]?.dob_char}</h6>
                  </div>
                  <div className="personal-content w-50">
                    <p className="dob">PH Category</p><span>:</span><h6>{resultData[0]?.ph_eligible}</h6>
                  </div>
                  </div>
                  <div className="d-flex w-100">
                  <div className="personal-content w-50">
                    <p className="dob">Community</p><span>:</span><h6>{resultData[0]?.caste}</h6>
                  </div>
                  <div className="personal-content w-50">
                    <p className="dob">EX-Servicemen</p><span>:</span><h6>{resultData[0]?.ex_service}</h6>
                  </div>
                  </div>
                  
                </div>
                <div className="personal-image">
                  <img
                    src={`${config.url.FILE_DOWNLOAD_URL + imgData}?t=${Date.now()}`}
                    className="img-fluid photo" alt="photo"/>
                </div>
              </div>
              <div className="table-head-results">
                {/* <h3>SCORE CARD DETAILS</h3> */}
                  <h3>STATEMENT OF MARKS</h3>
              </div>
              <ScoreDetails resultData={resultData} from="ScoreCard" />
              <div className="table-head-results">
                <h3>CATEGORY WISE PASS PERCENTAGE AND PASS MARK</h3>
              </div>
<ul className="pass-note-list">
  <li> Results shall be declared as per the schedule notified.
    The criteria for considering pass in APTET are as follows : (Total Marks – 150)
  </li>
</ul>
<div className="table-responsive align-center rounded-results">
  <table className="table results-table results-table-second table-bordered" role="presentation">
    <thead>
      <tr className="tr-first">
        <th className="text-center">Community</th>
        <th className="text-center">Pass Percentage</th>
        <th className="text-center">Pass Marks</th>
      </tr>
    </thead>

    <tbody>
      <tr>
        <td>i) OC </td>
        <td>60% and above</td>
        <td>90 Marks and above</td>
      </tr>

      <tr>
        <td>ii) BC</td>
        <td>50% and above</td>
        <td>75 Marks and above</td>
      </tr>

      <tr>
        <td>iii) SC / ST / PwBD & Ex-Servicemen</td>
        <td>40% and above</td>
        <td>60 Marks and above</td>
      </tr>
    </tbody>
  </table>
</div>
 {/* <div className="guidlines">
                <div className="guid-head">
                  <h4>GUIDELINES AND INSTRUCTIONS TO CANDIDATES</h4>
                </div>
                <div className="guid-body">
                  <ol className="guid-ol">
                    {inst_res?.map((item, index) => (<li key={index}>{item?.label}</li>))}
                    {hasResultsAccess &&
                      <li>If you have any objections regarding your TET highest score details mentioned above, you can submit valid updated information through the following link:
                        <button type="button" onClick={() => { navigate('/TetObjections') }} className="btn btn-link btn-sm">👉 Click here</button> to provide your correct TET highest score details. </li>}
                    <li>Candidates need to produce the relevant certificates as per application form at the time of verification of certificates.</li>

                  </ol>
                </div>
              </div> */}
              {/* <img src="../img/aptett-water.png" className="img-fluid apdsc-water1" alt="water-mark1" /> */}
              {/* <img src="../img/aptett-water.png" className="img-fluid apdsc-water2" alt="water-mark2" /> */}
              {/* <img src="../img/aptett-water.png" className="img-fluid apdsc-water3" alt="water-mark3" /> */}
              {/* <img src="../img/aptet-water.png" className="img-fluid apdsc-water4" alt="water-mark4" /> */}
              {/* <img src="../img/aptet-water.png" className="img-fluid apdsc-water5" alt="water-mark5" /> */}
              <img src="../img/APTET.png" className="img-fluid apdsc" alt="apdsc" />
            </div>
          </div>
        </div>)}
      {showRstatus === false && (<div className="alert alert-warning"> No Data Found </div>)}
    </div>
  );
}
